import { connect } from 'react-redux'

import component from 'components/Types'

const mapActionCreators = {
}

const mapStateToProps = (state) => ({
  types: state.types
})

export default connect(mapStateToProps, mapActionCreators)(component)



// WEBPACK FOOTER //
// ./src/routes/Types/containers/TypesContainer.js